// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1rRn0","search":"Settings_search__3zP9E","filter":"Settings_filter__2qgAJ"};